import {
  EKwikUIInputRadioChipOrientation,
  EKwikUIInputRadioChipSize,
  VKwikUIInputRadioChipOrientation,
  VKwikUIInputRadioChipSize
} from "./input-radio-chip.definitions";

export const isValidKeyValue = (key: string, value: any): boolean => {
  const isBoolean = (x: boolean) => typeof x === "boolean";
  const isString = (x: string) => typeof x === "string";

  const methods = {
    disabled: isBoolean,
    focus: isBoolean,
    formControlName: isString,
    id: isString,
    invalid: isBoolean,
    items: Array.isArray,
    label: isString,
    orientation: (x: EKwikUIInputRadioChipOrientation) =>
      VKwikUIInputRadioChipOrientation.includes(x),
    placeholder: isString,
    size: (x: EKwikUIInputRadioChipSize) =>
      VKwikUIInputRadioChipSize.includes(x)
  };

  return methods[key] && methods[key](value);
};
